import React from 'react';
import { useSelector } from 'react-redux';
import { SEOStripItem } from '../SEOStripItem';
import { VerticalDetailsService } from '../../../services/vertical-details.service';

export const SEOStripContainer = () => {
    const { verticalDetails: { seoStrip } } = useSelector((state) => state.app);

    if (seoStrip === null || seoStrip.title === null || !seoStrip.items.length) {
        return null;
    }
    const blocksByChunks = VerticalDetailsService.chunks(seoStrip.items, VerticalDetailsService.chunkSize);
    // wrap by chunks
    const blockItems = blocksByChunks.map((chunk, chunkIndex) => {
        const chunks = chunk.map((item, index) => <SEOStripItem key={chunkIndex + '_' + index} item={item} />);
        return <div className='footer-blocks-strip__grid' key={chunkIndex}>{chunks}</div>;
    });

    return (
        <div className='footer-blocks-strip__container'>
            <div className='footer-blocks-strip__wrapper'>
                <div className='footer-blocks-strip__title'>
                    <h1 className="footer-blocks-strip__title-headline"
                        dangerouslySetInnerHTML={{ __html: seoStrip.title }}
                    />
                </div>
                <div className='footer-blocks-strip-grid--wrapper'>
                    {blockItems}
                </div>
            </div>
        </div>
    );
};
